import { useRestResourceHook } from "../use-rest-resource-hook";
import {
  GetHomeMenuDataListRequest,
  GetHomeMenuDataListResponse,
  HomeRestResource,
} from ".";

export const useGetHomeMenuDataList = () =>
  useRestResourceHook<GetHomeMenuDataListRequest, GetHomeMenuDataListResponse>(
    (request) => HomeRestResource.getHomeMenuDataList(request),
  );
